import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-free-dragging',
    templateUrl: './free-dragging.component.html',
    styleUrls: ['./free-dragging.component.scss'],
    standalone: false
})
export class FreeDraggingComponent {
  @Input() dragIcon: string;
  @Input() xOffSet: number = 0;
  @Input() yOffSet: number = 0;
  @Input() boundaryQuery: string = "body";
  @Input() dragIconPosition: 'top'|'bottom'|'left'|'rigth'|'x-axis'|'y-axis'   = 'x-axis';
  @Input() maxWidth: string = "750px";
  @Input() maxHeight: string = "64px";
  @Input() padding: string = "16px";
  @Input() borderRadius: string = "32px";
  @Input() border: string = "1px solid rgba(255, 255, 255, 0.23)";
  @Input() background: string = "#121212";
}
